module.exports = __webpack_public_path__ + "static/media/wh-logo-withstripes.d3e6ab70.png";